import { configureStore } from '@reduxjs/toolkit';
import questionsReducer from './reducers/question';
export const storeOptions = {
    reducer: {
        questions: questionsReducer,
    },
};
const store = configureStore(storeOptions);
export default store;
